
import Vue from "vue";
import marked from "marked";
import axios from "axios";
import { upgradeImagesInElement, ImageUpgradeHandle } from "@/utils/progressiveImages";

let rendererMD = new marked.Renderer();
marked.setOptions({
  renderer: rendererMD,
  gfm: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
});
rendererMD.heading = function (text, level) {
  return `<h${level} style="margin-bottom:20px;margin-top:20px">${text}</h${level}>`;
};
rendererMD.link = function (href, title, text) {
  return `<a style="color:var(--color-primary);text-decoration:none;" href=${href}>${text}</a>`;
};

export default Vue.extend({
  data: () => ({
    name: "",
    date: "",
    content: "",
    _imageUpgradeHandle: null as ImageUpgradeHandle | null,
  }),
  computed: {
    compiledMarkdown(): string {
      return marked(this.content);
    },
  },
  mounted() {
    axios
      .post(Vue.prototype.apiUrl("get-item-by-id"), {
        collection: "article",
        _id: this.$route.params.id,
      })
      .then((response) => {
        let tmp = (response.data as any)[0];
        this.name = tmp.name;
        this.date = new Date(tmp.date).toISOString().split("T")[0];
        this.content = Vue.prototype.replaceLocalhostInContent(tmp.content);
        this.$nextTick(() => {
          const root = this.$refs.articleBody as HTMLElement | undefined;
          if (root) this._imageUpgradeHandle = upgradeImagesInElement(root);
        });
      });
  },
  beforeDestroy() {
    if (this._imageUpgradeHandle) {
      this._imageUpgradeHandle.destroy();
      this._imageUpgradeHandle = null;
    }
  },
});
